import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit {

  constructor(private customerService:ServiceService,private route: ActivatedRoute, private router: Router) { }
   
  //------function for routing-----------
  CustomerDetails(){
    this.router.navigateByUrl(('admin/customer-details'));  
  }
  
  //--------function which give id of selected customer---------
  getValue = (item : string) =>{
     
    this.customerService.setCustomerId(item)
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  
  }

  output:any=[];
  //getUrl='http://192.241.151.66:5000/viewCustomers';
  //searchCustomerUrl="http://192.241.151.66:5000/viewCustomers?customer_name="
  count=0;
  search:string='';
  isShownCustomer=false
  customer:any=[];
  Pagingflag=0
  loaderShown=true;
  CardShown=false;
  next_status=false;
  prv_status=false;
//-------------function for search--------------------
Search(){
  this.count=0
  console.log("customer search",this.search);
  
  this.loaderShown=true;
  this.CardShown=false;
  this.output=[];
  if(this.search!='')
  {
  
  this.isShownCustomer=true;
  this.customerService.NewSearchCustomer(this.search).subscribe((res)=>{
  this.output=res.data
  console.log("output1=",this.output)
  this.loaderShown=false;
  this.CardShown=true;
  })
 }
 else{
   //-------api get()calling-------------
   this.customerService.ViewCustomer("").subscribe((res)=>{
    this.output=res.data
    console.log("output2=",this.output)
    this.Pagingflag=0

    this.loaderShown=false;
    this.CardShown=true;
    })

 }
}
//----------function routing to edit customer---------
EditCustomer(){
  this.router.navigateByUrl(('admin/edit-customer'));  
  console.log("call edit product")
}

  //function for going to next page
    clicks_next(){
      this.next_status=true;
      if(this.search!='')
      {
        console.log("click next",this.search)
        this.count=this.count+1;
        this.customerService.NewSearchCustomer(this.search+'&offset='+this.count+'&limit=20').subscribe((res)=>{
        this.output=res.data
        this.next_status=false;
      })
      
      }
      else{
      this.count=this.count+1;
      //-------api get()calling for next page-------------
      this.customerService.ViewCustomer('offset='+this.count+'&limit=20').subscribe((res)=>{
      this.output=res.data
      this.next_status=false;
      })
    }
    }
    
    //function for going to previous page
    clicks_previous(){
      this.prv_status=true;
     if(this.search!='')
     {
      this.count=this.count-1;
      if(this.count<0)
      {
        this.count=0
      }
      this.customerService.NewSearchCustomer(this.search+'&offset='+this.count+'&limit=20').subscribe((res)=>{
      this.output=res.data
      this.prv_status=false;
      })
    }
    else{

      this.count=this.count-1;
      if(this.count<0)
      {
        this.count=0
      }
      //-------api get()calling for previous page-------------
      this.customerService.ViewCustomer('offset='+this.count+'&limit=20').subscribe((res)=>{
      this.output=res.data
      this.prv_status=false;
      })
    }
    }
  ngOnInit(): void {

     //-------api get()calling-------------
   this.customerService.ViewCustomer("").subscribe((res)=>{
   this.output=res.data
   console.log("customerlist=",this.output)
   this.loaderShown=false
   this.CardShown=true
   })
  }

}
